export const QUESTIONS = [
  {
    id: 1,
    question: "Si nous habitons à une heure de route l'un de l'autre, comment envisages-tu la relation ?",
    theme: "PROXIMITÉ",
    cards: [
      { arcana: "Ça me va très bien", numeral: "PROXIMITÉ", icon: "car", answer: "Une heure de route ne fait pas peur quand on aime", affinity: "bateleur" },
      { arcana: "On alterne les trajets", numeral: "PROXIMITÉ", icon: "compass", answer: "Chacun fait un bout de chemin vers l'autre", affinity: "papesse" },
      { arcana: "On se retrouve le week-end", numeral: "PROXIMITÉ", icon: "hourglass", answer: "Des retrouvailles qui valent l'attente", affinity: "comete" },
      { arcana: "Je préfère la proximité", numeral: "PROXIMITÉ", icon: "pin", answer: "Le quotidien se partage de près", affinity: "lune" },
    ],
  },
  {
    id: 2,
    question: "Est-ce que tu envisages d'avoir des / d'autres enfants ?",
    theme: "FAMILLE",
    cards: [
      { arcana: "Oui, j'en rêve", numeral: "FAMILLE", icon: "baby", answer: "Une famille qui s'agrandit, quelle aventure", affinity: "papesse" },
      { arcana: "Peut-être, avec la bonne personne", numeral: "FAMILLE", icon: "moon", answer: "Tout dépend de la rencontre", affinity: "lune" },
      { arcana: "Non, ma tribu est complète", numeral: "FAMILLE", icon: "home", answer: "Mon bonheur est déjà là", affinity: "soleil" },
      { arcana: "Non, ce n'est pas mon projet", numeral: "FAMILLE", icon: "plane", answer: "Mon chemin s'écrit autrement", affinity: "bateleur" },
    ],
  },
  {
    id: 3,
    question: "Quelle importance accordes-tu à ta famille dans ton quotidien ?",
    theme: "FAMILLE",
    cards: [
      { arcana: "Elle est au centre de tout", numeral: "FAMILLE", icon: "home", answer: "Mes dimanches sont en famille", affinity: "papesse" },
      { arcana: "Très présente, mais je garde mon espace", numeral: "FAMILLE", icon: "moon", answer: "Les miens, mais ma vie aussi", affinity: "lune" },
      { arcana: "On se retrouve aux grandes occasions", numeral: "FAMILLE", icon: "party", answer: "Chaque retrouvaille est une fête", affinity: "comete" },
      { arcana: "Ma famille, c'est aussi mes amis", numeral: "FAMILLE", icon: "smile", answer: "La famille qu'on choisit compte autant", affinity: "soleil" },
    ],
  },
  {
    id: 4,
    question: "Quand tu commences à t'attacher, quels sont les signes ?",
    theme: "PERSONNALITÉ",
    cards: [
      { arcana: "Je pense à l'autre tout le temps", numeral: "PERSONNALITÉ", icon: "moon", answer: "Mon esprit s'envole sans prévenir", affinity: "lune" },
      { arcana: "Je deviens très tactile", numeral: "PERSONNALITÉ", icon: "heart", answer: "Les gestes parlent avant les mots", affinity: "soleil" },
      { arcana: "J'en parle à tout le monde", numeral: "PERSONNALITÉ", icon: "chat", answer: "Impossible de garder ça pour moi", affinity: "etoile" },
      { arcana: "Je multiplie les petites attentions", numeral: "PERSONNALITÉ", icon: "hands", answer: "Un café, un message, une attention", affinity: "papesse" },
    ],
  },
  {
    id: 5,
    question: "Quelle est la valeur essentielle à tes yeux dans une relation amoureuse ?",
    theme: "VALEURS",
    cards: [
      { arcana: "L'honnêteté", numeral: "VALEURS", icon: "chat", answer: "La vérité, toujours", affinity: "etoile" },
      { arcana: "La fidélité", numeral: "VALEURS", icon: "infinity", answer: "Se choisir, chaque jour", affinity: "lune" },
      { arcana: "Le respect", numeral: "VALEURS", icon: "hands", answer: "S'écouter sans se blesser", affinity: "papesse" },
      { arcana: "La joie de vivre", numeral: "VALEURS", icon: "party", answer: "Rire ensemble, c'est déjà aimer", affinity: "comete" },
    ],
  },
  {
    id: 6,
    question: "Face à un conflit important dans le couple, comment réagis-tu ?",
    theme: "VALEURS",
    cards: [
      { arcana: "J'en parle tout de suite", numeral: "VALEURS", icon: "chat", answer: "Les mots avant les non-dits", affinity: "etoile" },
      { arcana: "Je prends du recul", numeral: "VALEURS", icon: "moon", answer: "Réfléchir, puis revenir vers l'autre", affinity: "lune" },
      { arcana: "Je cherche une solution concrète", numeral: "VALEURS", icon: "hands", answer: "À deux, on répare tout", affinity: "papesse" },
      { arcana: "Je dédramatise avec humour", numeral: "VALEURS", icon: "smile", answer: "Un sourire pour apaiser la tempête", affinity: "comete" },
    ],
  },
  {
    id: 7,
    question: "À quoi ressemble ton équilibre idéal entre vie de couple et temps pour toi ?",
    theme: "STYLE DE VIE",
    cards: [
      { arcana: "Beaucoup de temps ensemble", numeral: "STYLE DE VIE", icon: "heart", answer: "Le quotidien se vit à deux", affinity: "soleil" },
      { arcana: "Ensemble, mais chacun ses moments", numeral: "STYLE DE VIE", icon: "moon", answer: "S'aimer sans se perdre", affinity: "lune" },
      { arcana: "Beaucoup d'indépendance", numeral: "STYLE DE VIE", icon: "plane", answer: "Deux vies qui se choisissent", affinity: "bateleur" },
      { arcana: "Un équilibre qui évolue", numeral: "STYLE DE VIE", icon: "chat", answer: "On en parle, on s'ajuste", affinity: "etoile" },
    ],
  },
  {
    id: 8,
    question: "De quelle manière montres-tu principalement ton attachement au quotidien ?",
    theme: "PERSONNALITÉ",
    cards: [
      { arcana: "Par les mots doux", numeral: "PERSONNALITÉ", icon: "chat", answer: "Des messages qui font sourire", affinity: "etoile" },
      { arcana: "Par les gestes tendres", numeral: "PERSONNALITÉ", icon: "heart", answer: "Un câlin vaut mille mots", affinity: "soleil" },
      { arcana: "Par des petites attentions", numeral: "PERSONNALITÉ", icon: "hands", answer: "Le café prêt avant même de demander", affinity: "papesse" },
      { arcana: "Par les petites surprises", numeral: "PERSONNALITÉ", icon: "gift", answer: "L'inattendu qui fait battre le cœur", affinity: "comete" },
    ],
  },
  {
    id: 9,
    question: "Si la personne que tu rencontres a déjà des enfants, est-ce un frein ?",
    theme: "FAMILLE",
    cards: [
      { arcana: "Pas du tout, bienvenue à la tribu", numeral: "FAMILLE", icon: "baby", answer: "Une famille, ça s'agrandit avec joie", affinity: "papesse" },
      { arcana: "Non, si chacun trouve sa place", numeral: "FAMILLE", icon: "moon", answer: "Avec de la douceur, tout s'arrange", affinity: "lune" },
      { arcana: "Ça dépend de l'organisation", numeral: "FAMILLE", icon: "hourglass", answer: "Il faut que ça reste simple pour tous", affinity: "bateleur" },
      { arcana: "J'ai besoin d'être la priorité", numeral: "FAMILLE", icon: "heart", answer: "Une place à part, rien qu'à moi", affinity: "soleil" },
    ],
  },
  {
    id: 10,
    question: "Quelle est ta principale force à apporter dans une relation ?",
    theme: "PERSONNALITÉ",
    cards: [
      { arcana: "Mon écoute", numeral: "PERSONNALITÉ", icon: "moon", answer: "Comprendre sans qu'on ait besoin de tout dire", affinity: "lune" },
      { arcana: "Ma tendresse", numeral: "PERSONNALITÉ", icon: "heart", answer: "Des bras qui apaisent tout", affinity: "soleil" },
      { arcana: "Ma joie de vivre", numeral: "PERSONNALITÉ", icon: "party", answer: "Le soleil même sous la pluie", affinity: "comete" },
      { arcana: "Ma solidité", numeral: "PERSONNALITÉ", icon: "shield", answer: "On peut compter sur moi, toujours", affinity: "papesse" },
    ],
  },
];
